import { render, staticRenderFns } from "./UserBranch.vue?vue&type=template&id=be03584e&scoped=true"
import script from "./UserBranch.vue?vue&type=script&lang=js"
export * from "./UserBranch.vue?vue&type=script&lang=js"
import style0 from "./UserBranch.vue?vue&type=style&index=0&id=be03584e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be03584e",
  null
  
)

export default component.exports